import { InfoOutlined as InfoOutlinedIcon } from 'components/icons';
import { Checkbox } from 'components/ui/checkbox';
import { Tooltip } from 'components/ui/tooltip';
import { t } from 'utils/getTranslations';

type Props = {
    onChange: (value: boolean) => void;
    value?: boolean;
};

const SearchMyCasesCheckbox = ({ onChange, value }: Props): JSX.Element => {
    return (
        <div className="flex flex-row items-center">
            <label className="text-body1 mr-2 inline-flex cursor-pointer items-center gap-2">
                <Checkbox
                    variant="secondary"
                    checked={value ?? false}
                    onCheckedChange={(checked) => onChange(checked)}
                />
                {t('timecards.form.search-my-cases')}
            </label>
            <Tooltip content={t('matters.tooltips.my-cases')} side="bottom">
                <InfoOutlinedIcon className="text-grey-400 ml-[1px] h-[1.2rem]" />
            </Tooltip>
        </div>
    );
};

export default SearchMyCasesCheckbox;
